import { baseResponseSchema } from 'services/api/api.types';
import { z } from 'zod/v4';

/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/

export enum periodsCode {
  DAILY = 'DD',
  WEEKLY = 'DW',
  MONTHLY = 'DM',
}

const accountLimitationTypeCodeSchema = z.enum(periodsCode);

const limitationRegistrationSchema = z.object({
  code: accountLimitationTypeCodeSchema,
  period: z.number(),
  minAmount: z.number(),
  maxAmount: z.number(),
  minPeriod: z.number().optional(),
  maxPeriod: z.number().optional(),
  defaultAmount: z.number().optional(),
  latencyPeriod: z.number(),
});

const accountLimitationTypesResponseSchema = baseResponseSchema.extend({
  responseObject: z.array(limitationRegistrationSchema),
});

type AccountLimitationTypesIResponse = z.infer<
  typeof accountLimitationTypesResponseSchema
>;

type AccountLimitationType = z.infer<typeof limitationRegistrationSchema>;

type NormalizedAccountLimitationTypes = Partial<
  Record<periodsCode, AccountLimitationType>
>;

type TransformedAccountLimitationResponse = ReturnType<
  typeof transformAccountLimitationsResponse
>;
/*-------------------------------------------------------------------------------------------------
 * transformer helper
 * -----------------------------------------------------------------------------------------------*/

const transformAccountLimitationsResponse = (
  response: AccountLimitationTypesIResponse,
) => {
  const normalized =
    response.responseObject.reduce<NormalizedAccountLimitationTypes>(
      (acc, item) => {
        acc[item.code] = item;
        return acc;
      },
      {},
    );

  return {
    normalized,
    list: response.responseObject,
  };
};

export {
  accountLimitationTypesResponseSchema,
  transformAccountLimitationsResponse,
};
export type {
  AccountLimitationTypesIResponse,
  NormalizedAccountLimitationTypes,
  TransformedAccountLimitationResponse,
};
